import { useState, useEffect } from 'react';
import st from './index.module.css';
import classNames from 'classnames';

const Timer = () => {
  const targetDate = new Date('2026-07-10T23:59:59').getTime();

  const getTimeLeft = () => {
    const now = new Date().getTime();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const format = num => String(num).padStart(2, '0');

  return (
    <div className="bg-[#000000] overflow-hidden py-[48px] text-white">
      <div className="container">
        <div className="flex flex-col gap-[40px]">
          <div className="flex flex-col items-center gap-[24px] relative">
            {/* <div className="absolute -top-[35px] right-[266px] md:block hidden">
              <div className={classNames('px-[10px] py-[6px] text-[#000000] bg-[#D7DF23] rounded-[40px] text-[16px] font-bold', st.pulse)}>
                Մնացել է 4 տեղ
              </div>
              <div className="relative left-1/2 -translate-x-1/2 max-w-max">
                <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.06226 9.75L7.83026e-05 1.88257e-07L12.1244 -8.71687e-07L6.06226 9.75Z" fill="#D7DF23" />
                </svg>
              </div>
            </div> */}
            <h2 className="md:text-[48px] text-[32px] font-medium md:leading-[59px] leading-[40px]">Հասցրե՛ք օգտվել</h2>
            <p className="text-[18px] flex flex-col items-center">
              <span className="font-thin text-center">Առաջարկները սահմանափակ քանակով են՝</span>
              <span className="font-semibold text-center">յուրաքանչյուրը 2 գործընկերոջ համար</span>
            </p>
          </div>
          <div className="flex flex-row justify-center items-center md:gap-[32px] gap-[12px]">
            <div className="flex flex-col gap-[8px]  items-center">
              <div className="flex flex-row md:gap-[32px] gap-[12px]">
                <span className="md:text-[96px] text-[38px] font-[600] md:leading-[150px] leading-[56px]">{format(timeLeft.days)}</span>
                <span className="md:text-[96px] text-[38px] font-[500]">:</span>
              </div>
              <span className="md:text-[24px] text-[10px] pr-[30px] font-extralight">օր</span>
            </div>
            <div className="flex flex-col gap-[8px]  items-center">
              <div className="flex flex-row md:gap-[32px] gap-[12px]">
                <span className="md:text-[96px] text-[38px] font-[600] md:leading-[150px] leading-[56px]">{format(timeLeft.hours)}</span>
                <span className="md:text-[96px] text-[38px] font-[500]">:</span>
              </div>
              <span className="md:text-[24px] text-[10px] pr-[30px] font-extralight">ժամ</span>
            </div>
            <div className="flex flex-col gap-[8px]  items-center">
              <div className="flex flex-row md:gap-[32px] gap-[12px]">
                <span className="md:text-[96px] text-[38px] font-[600] md:leading-[150px] leading-[56px]">{format(timeLeft.minutes)}</span>
                <span className="md:text-[96px] text-[38px] font-[500]">:</span>
              </div>
              <span className="md:text-[24px] text-[10px] pr-[30px] font-extralight">րոպե </span>
            </div>
            <div className="flex flex-col gap-[8px]  items-center">
              <span className="md:text-[96px] text-[38px] font-[600] md:leading-[150px] leading-[56px]">{format(timeLeft.seconds)}</span>
              <span className="md:text-[24px] text-[10px]  font-extralight">վայրկյան</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timer;
